import { acceptOrder, rejectOrder } from '../../../mocks/order-response.data';
import { AlkLogger } from '@alk/core';
import { IForwardOrderRequest, IPendingOrderRequest, IPlaceOrderIdResponse, ISpotOrderRequest } from '../../../interfaces';
import { injectable } from 'inversify';
import { IPlaceOrderAdapter } from './place-order-adapter.interface';

const PLACE_ORDER_DELAY = 200;

@injectable()
export class PlaceOrderAdapterMock implements IPlaceOrderAdapter {

    private orderRequestId = 0;

    placeSpotOrder(placeOrderRequest: ISpotOrderRequest): Promise<IPlaceOrderIdResponse>{

        AlkLogger.debug('[PlaceOrderAdapterMock#sendPlaceOrderRequest] request: ', placeOrderRequest);

        return this.placeOrderInternalOrder();
    }

    placeForwardOrder(placeOrderRequest: IForwardOrderRequest): Promise<IPlaceOrderIdResponse> {
        AlkLogger.debug('[PlaceOrderAdapterMock#placeForwardOrder] request: ', placeOrderRequest);

        return this.placeOrderInternalOrder();
    }

    placePendingOrder(placeOrderRequest: IPendingOrderRequest): Promise<IPlaceOrderIdResponse> {
        AlkLogger.debug('[PlaceOrderAdapterMock#placePendingOrder] request: ', placeOrderRequest);

        return this.placeOrderInternalOrder();
    }

    private readonly placeOrderInternalOrder = (): Promise<IPlaceOrderIdResponse> => new Promise((resolve) => {
        setTimeout(() => {
            const response: IPlaceOrderIdResponse =
                Math.random() > 0.3 ? acceptOrder(this.orderRequestId++) : rejectOrder(this.orderRequestId++);

            resolve(response);
        },
        PLACE_ORDER_DELAY);
    });
}
